module.exports = __webpack_public_path__ + "img/shiftWork.55ca9991.png";